// Business-time helpers (America/Toronto). Pure; used by the browser and by Node scripts.
import { wallToUtc } from "./time/zone";

export const BUSINESS_TZ = "America/Toronto";

const DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
const TIME_RE = /^(\d{2}):(\d{2})$/;

/** The UTC instant of a wall-clock date and time in `tz` (gap: later instant; ambiguous: first occurrence). */
export function zonedTimeToUtc(
  localDate: string,
  localTime: string,
  tz = BUSINESS_TZ,
): Date {
  const d = DATE_RE.exec(localDate);
  const t = TIME_RE.exec(localTime);
  if (!d || !t)
    throw new RangeError(`invalid local date/time: ${localDate} ${localTime}`);
  const [y, mo, da, h, mi] = [d[1], d[2], d[3], t[1], t[2]].map(Number);
  const calendar = new Date(Date.UTC(y, mo - 1, da));
  if (
    calendar.getUTCFullYear() !== y ||
    calendar.getUTCMonth() !== mo - 1 ||
    calendar.getUTCDate() !== da ||
    h > 23 ||
    mi > 59
  )
    throw new RangeError(`invalid local date/time: ${localDate} ${localTime}`);
  return wallToUtc(Date.UTC(y, mo - 1, da, h, mi), tz);
}

/** The calendar day (YYYY-MM-DD) of an instant in `tz`. */
export function localDateOf(instant: Date, tz = BUSINESS_TZ): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(instant);
}

/** Date (and time) of an ISO instant, in fr-CA or en-CA, in the business time zone. */
export function formatLeadDateTime(
  iso: string | null | undefined,
  locale: "fr" | "en",
  withTime = true,
): string {
  if (!iso) return "";
  return new Intl.DateTimeFormat(locale === "fr" ? "fr-CA" : "en-CA", {
    timeZone: BUSINESS_TZ,
    dateStyle: "medium",
    ...(withTime ? { timeStyle: "short" as const } : {}),
  }).format(new Date(iso));
}
